import React from 'react'
import styled from 'styled-components'

const getDetailText = value => (value ? String(value).trim() : '')

const getLocationDetails = (location, date) => {
  const locationText = getDetailText(location)
  const dateText = getDetailText(date)

  if (!locationText && !dateText) return null

  return (
    <>
      {locationText}
      {locationText && dateText && ' '}
      {dateText && <span>{dateText}</span>}
    </>
  )
}

const OfferDetails = ({ className, offer }) => {
  const fromLocation = offer.loading || offer.from
  const fromDate = offer.loadingDate || offer.fromDate
  const toLocation = offer.unloading || offer.to
  const toDate = offer.unloadingDate || offer.toDate
  const cargoDetails = [offer.container, offer.shipowner || offer.cargoType]
    .map(getDetailText)
    .filter(Boolean)
    .join(', ')
  const dateRange = [offer.startDate, offer.endDate]
    .map(getDetailText)
    .filter(Boolean)
    .join(' - ')
  const details = [
    { key: 'from', value: getLocationDetails(fromLocation, fromDate) },
    { key: 'to', value: getLocationDetails(toLocation, toDate) },
    { key: 'dateRange', value: dateRange },
    { key: 'cargoDetails', value: cargoDetails },
    { key: 'handlerCompany', value: getDetailText(offer.handlerCompany) },
    { key: 'handlerName', value: getDetailText(offer.handlerName) },
    { key: 'driver', value: getDetailText(offer.driver) },
    { key: 'driverPhone', value: getDetailText(offer.driverPhone) }
  ].filter(({ value }) => value)

  return (
    <div className={className}>
      <Text>
        {details.map(({ key, value }, index) => (
          <React.Fragment key={key}>
            {index > 0 && ', '}
            {value}
          </React.Fragment>
        ))}
      </Text>
    </div>
  )
}

export default styled(OfferDetails)`
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  min-height: 20px;
  line-height: 1;
`

const Text = styled.span`
  display: inline;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1;
  color: ${({ theme }) => theme.colors.ebonyClay.hex()};
  span {
    color: ${({ theme }) => theme.colors.ebonyClay.alpha(0.6).hex()};
  }
`
